/* ============================================================================
   KADI — V2 home : barres de scroll fines & draggables sous les carrousels.
   Chargé uniquement sur l'index. Chaque [data-scrollbar] est associé au .k2-track
   de sa section : thumb dont la largeur = proportion visible, position = scroll.
   Draggable + clic sur la piste pour sauter. Sans overflow → thumb masqué.
   ========================================================================== */
(function () {
  'use strict';
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  function setup(bar) {
    var section = bar.closest('section') || bar.parentNode;
    var track = section && section.querySelector('.k2-track');
    var thumb = bar.querySelector('[data-scrollbar-thumb]');
    if (!track || !thumb) return;

    function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function ratio()     { return track.clientWidth / track.scrollWidth; }

    function update() {
      var ms = maxScroll();
      if (ms <= 1) { bar.classList.add('is-static'); return; }
      bar.classList.remove('is-static');
      var w = Math.max(ratio() * 100, 8);
      thumb.style.width = w + '%';
      thumb.style.left = (track.scrollLeft / ms) * (100 - w) + '%';
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) { try { new ResizeObserver(update).observe(track); } catch (e) {} }

    // Drag du thumb (MAJ directe → fluide, indépendant de l'event scroll)
    var dragging = false, startX = 0, startScroll = 0;
    thumb.addEventListener('pointerdown', function (e) {
      dragging = true; startX = e.clientX; startScroll = track.scrollLeft;
      try { thumb.setPointerCapture(e.pointerId); } catch (er) {}
      e.preventDefault(); e.stopPropagation();
    });
    thumb.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var travel = bar.clientWidth * (1 - ratio());
      if (travel <= 0) return;
      track.scrollLeft = startScroll + (e.clientX - startX) * (maxScroll() / travel);
      update();
    });
    function endDrag() { dragging = false; }
    thumb.addEventListener('pointerup', endDrag);
    thumb.addEventListener('pointercancel', endDrag);

    // Clic sur la piste → saut à la position
    bar.addEventListener('pointerdown', function (e) {
      if (e.target === thumb || dragging) return;
      var rect = bar.getBoundingClientRect();
      track.scrollLeft = ((e.clientX - rect.left) / rect.width) * maxScroll();
      update();
    });

    update();
    window.addEventListener('load', update);
  }

  ready(function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-scrollbar]'), setup);
  });
})();
